// Copyright ©️ 2026 eVolve MEP, LLC

import type { Project, StrongOmit } from '@evolvemep/api-ts';

import { useProjectRequired } from 'components/Mantine/GlobalFilters/ProjectRequired';
import { ProjectSelect } from 'components/Mantine/GlobalFilters/ProjectSelect';
import type { SearchableSelectProps } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableSelect';

export type Props = StrongOmit<
  SearchableSelectProps<'shop/project', Project, 'projectId'>,
  'idKey' | 'paginatedGet' | 'getItemLabel' | 'value' | 'onChange'
> & {
  onChange?: (project: Project | null) => void;
};

export const GlobalProjectSelect = ({ onChange, ...props }: Props) => {
  const { selectedProject, setSelectedProject } = useProjectRequired();

  return (
    <ProjectSelect
      onChange={(v) => {
        setSelectedProject(v);
        onChange?.(v);
      }}
      value={selectedProject}
      {...props}
    />
  );
};
